import { render, staticRenderFns } from "./ReleaseNoteList.vue?vue&type=template&id=424bd987&scoped=true"
import script from "./ReleaseNoteList.vue?vue&type=script&lang=ts"
export * from "./ReleaseNoteList.vue?vue&type=script&lang=ts"
import style0 from "./ReleaseNoteList.vue?vue&type=style&index=0&id=424bd987&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424bd987",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
